

export const tableColumns = ['Id', 'Descrizione', 'Progressivo', 'Codice contenuto', 'Stato', 'Azioni'];
